<template>
  <v-card class="rounded-lg">
    <v-row>
      <v-col cols="5" class="ml-3">
        <a href="history-coin-gen" style="text-decoration: none;" class="grey--text text--darken-2">
          Coin Gen
          <br />
          {{ saldoCoinGen |toRupiah}}
        </a>
      </v-col>
      <v-divider class="my-3" vertical></v-divider>
      <v-col>
        <a href="user/wallet-bonus" style="text-decoration: none;" class="grey--text text--darken-2">
          Saldo Bonus
          <br />
          {{ saldo.total_balance|toRupiah }}
        </a>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState("cart", ["saldoCoinGen"]),
    // ...mapState("saldoSeller", ["saldo"]),
    ...mapState("saldoUser", ["saldo"])
  },
  created() {
    this.getSaldoCoinGen();
    this.getSaldoSummary();
  },
  methods: {
    ...mapActions("cart", ["getSaldoCoinGen"]),
    ...mapActions("saldoUser", ["getSaldoSummary"])
  }
};
</script>

<style lang="scss" scoped>
</style>